import { Component, Input } from '@angular/core';

import { OpportunityType } from '../../../coaching-base/opportunity';
import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { Opportunity } from '../models/oa.model';

@Component({
    selector: 'goal-score',
    templateUrl: './goal-score.component.html',
})
export class GoalScoreComponent {
    @Input() opportunity: Opportunity;

    OpportunityType = OpportunityType;

    i18n = TranslationKeyMap;
}
